import getters from './getters'
import actions from './actions'
import mutations from './mutations'

const state = {
  fbToken: 'AIzaSyDnw3ZApzMHOrbpa13I0xfnRiibKCgjQ-I',
  token: ''
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
